import { render, staticRenderFns } from "./InvitationIcon.vue?vue&type=template&id=7a16ed8e&scoped=true&"
import script from "./InvitationIcon.vue?vue&type=script&lang=js&"
export * from "./InvitationIcon.vue?vue&type=script&lang=js&"
import style0 from "./InvitationIcon.vue?vue&type=style&index=0&id=7a16ed8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a16ed8e",
  null
  
)

export default component.exports